module.exports = "#title-extra-info span {\n  padding-left: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/logging/error-log/error-log.component.scss
// module id = ./src/app/components/framework/logging/error-log/error-log.component.scss
// module chunks = main